import React, { Fragment } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import { formatTimeStamp } from 'lib/util';

const HistoricsReportRow = ({
  locations = [],
  record,
  handleToggleCollapsed,
  handleGeneratePDF,
  isSaving,
  handleAccept,
  handleReject,
  collapsed,
  t,
}) => {
  return (
    <Fragment>
      <tr>
        <td className="text-center align-middle">
          <span
            className={classnames('badge ', {
              'badge-success': record.status === 'ACCEPTED',
              'badge-warning': record.status === 'PENDING',
              'badge-danger': record.status === 'REJECTED',
            })}
          >
            {t(`assets.fields.historics.statusName.${record.status}`)}
          </span>
        </td>
        <td className="text-center align-middle">{formatTimeStamp(record.createdAt)}</td>
        <td className="text-center align-middle">
          {record.reviewDate ? formatTimeStamp(record.reviewDate) : ''}
        </td>
        <td className="text-center align-middle">
          {record._createdBy
            ? `${record._createdBy.name} ${record._createdBy.lastname}`
            : 'Sistema'}
        </td>
        {/* <td className="text-center align-middle">{`${record._createdBy.name} ${record._createdBy.lastname} (${record._createdBy.email})`}</td> */}
        <td className="text-center align-middle">
          {record._reviewedBy
            ? `${record._reviewedBy.name} ${record._reviewedBy.lastname}`
            : 'Sistema'}
        </td>
        {/* <td className="text-center align-middle">{`${record._reviewedBy.name} ${record._reviewedBy.lastname} (${record._reviewedBy.email})`}</td> */}
        <td className="text-center align-middle">{record._asset.number}</td>
        <td className="text-center align-middle">{record._asset.name}</td>
        <td className="text-center align-middle">
          {record._asset.location
            ? record._asset.location
                .split('.')
                .map((p) => locations[p] && locations[p].name)
                .filter((l) => l)
                .join(' , ')
            : ''}
        </td>
        <td className="text-center align-middle">
          {record._asset._account ? record._asset._account.name : ''}
        </td>
        <td className="text-center align-middle">
          {record._asset._subaccount ? record._asset._subaccount.name : ''}
        </td>
        <td className="text-center align-middle">
          {record._asset._costCenter ? record._asset._costCenter.name : ''}
        </td>
        <td className="text-center align-middle">
          {record._asset._employee
            ? `${record._asset._employee.name} ${record._asset._employee.lastname}`
            : 'Sin empleado asignado'}
        </td>
        <td
          className={`text-center align-middle 
          ${
            record._asset._employee == null
              ? 'table-default'
              : record._asset.validated
              ? 'table-success'
              : 'table-info'
          }`}
        >
          {record._asset._employee == null
            ? 'Sin Asignar'
            : record._asset.validated
            ? 'Aceptado'
            : 'Por aceptar'}
        </td>
        {/* <td>{record._asset.position}</td> */}
        {/* <td className="text-center">{record._asset.total}</td> */}
        <td className="text-center">
          <a
            className="btn btn-outline-success btn-sm mx-2"
            href="#expand"
            onClick={(e) => {
              e.preventDefault();
              handleToggleCollapsed();
            }}
          >
            {t(!collapsed ? 'reports.historics.hideAssets' : 'reports.historics.showAssets')}
            &nbsp;
            <i
              className={classnames('fa', {
                'fa-angle-down': collapsed,
                'fa-angle-up': !collapsed,
              })}
            />
          </a>
          {record.status === 'PENDING' && (
            <a
              className={classnames('btn btn-outline-danger btn-sm mx-1', {
                'is-loading': isSaving,
              })}
              href={'#reject-historic'}
              onClick={(e) => {
                e.preventDefault();
                handleReject(record);
              }}
            >
              {t('actions.reject')}
            </a>
          )}
          {record.status === 'PENDING' && (
            <a
              className={classnames('btn btn-outline-primary btn-sm mx-1', {
                'is-loading': isSaving,
              })}
              href={'#accept-historic'}
              onClick={(e) => {
                e.preventDefault();
                handleAccept(record);
              }}
            >
              {t('actions.accept')}
            </a>
          )}
          {/* <a
            className="btn btn-outline-primary btn-sm"
            href="#export"
            onClick={(e) => {
              e.preventDefault();
              console.log(record);

              handleGeneratePDF(record);
            }}
          >
            {t("actions.exportPDF")}
          </a> */}
        </td>
      </tr>
      <tr className={classnames('table-active', { 'd-none': collapsed })}>
        <td colSpan="7">
          <div className="table-reponsive position-relative">
            <table className="table table-condensed">
              <thead>
                {/* <tr className="text-center">
                <th colSpan="4">{t('reports.historics.assigned')}</th>
              </tr> */}
                {/* <tr>
                  <th>{t("reports.fields.historics.number")}</th>
                  <th>{t("reports.fields.historics.name")}</th>
                  <th>{t("reports.fields.historics.brand")}</th>
                  <th>{t("reports.fields.historics.model")}</th>
                  <th>{t("reports.fields.historics.serie")}</th>
                </tr> */}
                <tr>
                  <th width="20%">{t('assets.fields.historics.field')}</th>
                  <th width="35%">{t('assets.fields.historics.before')}</th>
                  <th width="35%">{t('assets.fields.historics.after')}</th>
                  {record.status === 'PENDING' && (
                    <th width="5%">
                      <a
                        className={classnames('btn btn-outline-danger btn-sm mx-1', {
                          'is-loading': isSaving,
                        })}
                        href={'#reject-historic'}
                        onClick={(e) => {
                          e.preventDefault();
                          handleReject(record);
                        }}
                      >
                        {t('actions.reject')}
                      </a>
                    </th>
                  )}
                  {record.status === 'PENDING' && (
                    <th width="5%">
                      <a
                        className={classnames('btn btn-outline-primary btn-sm mx-1', {
                          'is-loading': isSaving,
                        })}
                        href={'#accept-historic'}
                        onClick={(e) => {
                          e.preventDefault();
                          handleAccept(record);
                        }}
                      >
                        {t('actions.accept')}
                      </a>
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {record.differences.map((diff, index) =>
                  diff.field === 'location' && diff.before && diff.after ? (
                    <tr key={index}>
                      <td>{t(`assets.fields.${diff.field}`)}</td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.before
                            .split('.')
                            .map((p) => locations[p] && locations[p].name)
                            .filter((l) => l)
                            .join(' <br/> '),
                        }}
                      />
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.after
                            .split('.')
                            .map((p) => locations[p] && locations[p].name)
                            .filter((l) => l)
                            .join(' <br/> '),
                        }}
                      />
                    </tr>
                  ) : diff.field === 'files' ? (
                    <tr key={index}>
                      <td>{t(`assets.fields.${diff.field}`, { defaultValue: diff.field })}</td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.before.split(', ').join(' <br/>'),
                        }}
                      />
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.after.split(', ').join(' <br/>'),
                        }}
                      />
                    </tr>
                  ) : diff.field === 'notes' ? (
                    <tr key={index}>
                      <td>{t(`assets.fields.${diff.field}.text`, { defaultValue: diff.field })}</td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.before.split(', ').join(' <br/>'),
                        }}
                      />
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.after.split(', ').join(' <br/>'),
                        }}
                      />
                    </tr>
                  ) : (
                    <tr key={index}>
                      <td>
                        {t(`assets.fields.${diff.field}`, { defaultValue: diff.field || '-' })}
                      </td>
                      <td>
                        {t(
                          typeof diff.before === 'boolean'
                            ? diff.before
                              ? 'common.yes'
                              : 'common.no'
                            : typeof diff.before === 'string'
                            ? diff.before
                            : JSON.stringify(diff.before)
                        )}
                      </td>
                      <td>
                        {t(
                          typeof diff.after === 'boolean'
                            ? diff.after
                              ? 'common.yes'
                              : 'common.no'
                            : typeof diff.after === 'string'
                            ? diff.after
                            : JSON.stringify(diff.after)
                        )}
                      </td>
                    </tr>
                  )
                )}
                {/* {record.assets.map((asset) => (
                  <tr key={asset.id}>
                    <td>{asset.number}</td>
                    <td>{asset.name}</td>
                    <td>{asset.brand}</td>
                    <td>{asset.model}</td>
                    <td>{asset.serie}</td>
                  </tr>
                ))} */}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </Fragment>
  );
};

export default translate()(HistoricsReportRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/historics/HistoricsReportRow.js